<template>
  <div>
    <div
      :style="indexCls()"
      @click="onMask"
      v-if="$slots.default"
      :class="{ mask }"
    ></div>

    <div
      key="content"
      :class="{ closeable, [align.toLowerCase()]: true }"
      v-if="$slots.default"
      class="vue-simple-drawer cover"
      :style="indexCls()"
    >
      <!-- Sticky Header -->
      <div
        v-if="$slots.header || $scopedSlots.header"
        class="drawer-header"
        :class="{ 'sticky-active': showStickyHeader }"
      >
        <slot name="header" :hide="close"></slot>
      </div>

      <!-- Close Button -->
      <div @click.stop="close" v-if="closeable" class="close-btn">
        <div class="leftright"></div>
        <div class="rightleft"></div>
      </div>

      <!-- Scrollable Content Area -->
      <div
        ref="drawerContent"
        class="drawer-content"
        :class="{ 'has-header': $slots.header || $scopedSlots.header, 'has-footer': $slots.footer || $scopedSlots.footer }"
        @scroll="handleScroll"
      >
        <slot></slot>
      </div>

      <!-- Sticky Footer -->
      <div
        v-if="$slots.footer || $scopedSlots.footer"
        class="drawer-footer"
        :class="{ 'sticky-active': showStickyFooter }"
      >
        <slot name="footer" :hide="close"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    align: {
      type: String,
      default: "right",
      validator: function(value) {
        // The value must match one of these strings
        return ["left", "up", "right", "down"].indexOf(value) !== -1;
      }
    },
    closeable: {
      type: Boolean,
      default: true
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default() {
        return this.simpleDrawerIndex;
      }
    }
  },
  provide() {
    return {
      simpleDrawerIndex: this.computedIndex + 1
    };
  },
  inject: {
    simpleDrawerIndex: { default: 1000 }
  },
  data() {
    return {
      scrollTop: 0,
      scrollHeight: 0,
      clientHeight: 0,
      scrollThrottleTimer: null
    };
  },

  mounted() {
    // Prevent body scroll when drawer is mounted
    this.lockBodyScroll();

    // Initialize scroll dimensions after DOM is ready
    this.$nextTick(() => {
      this.updateScrollDimensions();
    });
  },

  beforeDestroy() {
    // Restore body scroll when drawer is destroyed
    this.unlockBodyScroll();

    // Clean up throttle timer
    if (this.scrollThrottleTimer) {
      clearTimeout(this.scrollThrottleTimer);
    }
  },

  methods: {
    close() {
      this.$emit("close");
    },
    onMask() {
      if (this.maskClosable) {
        this.close();
      }
    },
    indexCls(offset = 0) {
      return {
        zIndex: this.computedIndex + offset
      };
    },
    lockBodyScroll() {
      // Save current scroll position
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Add class to body to prevent scrolling
      document.body.classList.add('drawer-open');
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    },
    unlockBodyScroll() {
      // Remove class and restore scroll position
      document.body.classList.remove('drawer-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';

      // Restore scroll position
      if (this.scrollPosition !== undefined) {
        window.scrollTo(0, this.scrollPosition);
      }
    },
    handleScroll() {
      // Throttle scroll events for performance (16ms ≈ 60fps)
      if (this.scrollThrottleTimer) {
        return;
      }

      this.scrollThrottleTimer = setTimeout(() => {
        this.updateScrollDimensions();
        this.scrollThrottleTimer = null;
      }, 16);
    },
    updateScrollDimensions() {
      const contentEl = this.$refs.drawerContent;
      if (!contentEl) return;

      this.scrollTop = contentEl.scrollTop;
      this.scrollHeight = contentEl.scrollHeight;
      this.clientHeight = contentEl.clientHeight;
    }
  },
  computed: {
    alignInCls() {
      return `animated bounceIn${this.align.toLowerCase()}`;
    },
    alignOutCls() {
      return `animated bounceOut${this.align.toLowerCase()}`;
    },
    alighCloseCls() {
      return `close-${this.align.toLowerCase()}`;
    },
    computedIndex() {
      return this.zIndex || this.simpleDrawerIndex;
    },
    showStickyHeader() {
      // Show sticky header when scrolled down more than 50px
      return this.scrollTop > 50;
    },
    showStickyFooter() {
      // Show sticky footer when near bottom (within 50px of bottom)
      const maxScroll = this.scrollHeight - this.clientHeight;
      return this.scrollTop > maxScroll - 50;
    }
  }
};
</script>
<style lang="scss">
@import "index";
</style>
